import type { PrimaryGoal } from '@shared/types';

/**
 * KPI label per design.md V15 derivations table: "lead_generation → Leads ·
 * sales_conversion → Sales · customer_retention → Repeat customers ·
 * product_launch / market_expansion / null → Conversions". `brand_awareness`
 * has no dedicated entry in that table either, so it shares the same
 * "Conversions" fallback. Shared by `projections` and `tactic_measurement`
 * (both Stream AG) so the two slides never disagree on what the number is
 * called.
 */
export function kpiLabelForGoal(goal: PrimaryGoal | null | undefined): string {
  switch (goal) {
    case 'lead_generation':
      return 'Leads';
    case 'sales_conversion':
      return 'Sales';
    case 'customer_retention':
      return 'Repeat customers';
    default:
      return 'Conversions';
  }
}

/** Singularizes a KPI label for "Cost per {kpi}" phrasing ("Leads" -> "lead",
 * "Repeat customers" -> "repeat customer"). Naive trailing-s strip, which
 * covers every value `kpiLabelForGoal` returns. */
export function kpiLabelSingular(label: string): string {
  const lower = label.toLowerCase();
  return lower.endsWith('s') ? lower.slice(0, -1) : lower;
}
